import mixpanelBrowser from 'mixpanel-browser';

const isProd = process.env.NODE_ENV === 'production';

const mixpanel = {
  init: (...args) => {
    if (isProd) mixpanelBrowser.init(...args);
  },
  identify: (...args) => {
    if (isProd) mixpanelBrowser.identify(...args);
  },
  track: (...args) => {
    if (isProd) mixpanelBrowser.track(...args);
  },
  people: {
    set: (...args) => {
      if (isProd) mixpanelBrowser.people.set(...args);
    },
  },
};

export default mixpanel;
